import packsService from '../../../services/packs/packs.service'
import useHttpLoader from '../../../hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import sandboxAtom from '../../Sandbox/sandbox.atom'
import navigationAtom from '../../Navigation/navigation.atom'
import { IPack } from '../../../services/packs/packs.types'

const useLoadPack = () => {
  const { wait, loading } = useHttpLoader()
  const setSandboxState = useSetRecoilState(sandboxAtom)
  const setNavigationState = useSetRecoilState(navigationAtom)

  const load = (pack: IPack) => {
    wait(packsService.getFullPack(pack.id), (resp) => {
      const updatedState = {
        version: pack,
        draftTask: resp.tasks[0],
        tasks: resp.tasks,
        groups: resp.groups,
        sets: resp.sets,
        levels: resp.levels,
      }

      const navRocket = resp.sets[0].id
      const navStar = resp.groups.find((g) => g.set === resp.sets[0].id).id
      const navLevel = resp.tasks.find((t) => t.group === navStar).id
      setNavigationState({ rocket: navRocket, star: navStar, level: navLevel })
      setSandboxState(updatedState)
    })
  }

  return { load, loading }
}

export default useLoadPack
